import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useExportServicesPerformedReport = (payload) => {
  return useMutation(async () => {
    return http.get(HTTP_ENDPOINTS.getServiceSales(), { params: payload });
  });
};
